import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=fdd2a03e&"
import script from "./VDropdown.vue?vue&type=script&lang=js&"
export * from "./VDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports